import { Button, Drawer, InputNumber, List, Slider, Table, Tag } from "antd";
import styled from "styled-components";

export const MySlider = styled(Slider)`
margin : 1rem 1rem 0rem 1rem;
`;

export const Container = styled.div`
display : flex;
justify-content: space-between;
`;

export const Input = styled(InputNumber)`
margin : 10px 0rem 0rem 0rem;
`;

export const RoundedTable = styled(Table)`
border-radius : 5px
`;

